export enum GameState {
  Playing = "playing",
  GameOver = "gameOver",
  Win = "win",
}
